import React, { useContext, useState, useEffect } from 'react'
import 'C:/apps/ideafy/src/components/styles/MainPage.css'
import { useGlobalState } from '../globalState/globalState'
import { Link ,useHistory } from 'react-router-dom'
import 'C:/apps/ideafy/src/components/styles/SecondPage.css'
import 'C:/apps/ideafy/src/components/styles/SecondPageMobile.css'
import { Formik, Field, Form } from 'formik';
import { CheckboxWithLabel } from 'formik-material-ui';
import Firebase from '../config/Firebase';
import { v4 as uuidv4 } from 'uuid';

const SumbitInterests = () => {
    const [email, setEmail] = useGlobalState('email');
    const [emailIsWritten, setEmailIsWritten] = useGlobalState('emailIsWritten');
    const [currentId, setCurrentId] = useGlobalState('currentId');

    const history = useHistory()


    

    if (emailIsWritten == false){
        history.push("/")
    }


    return (
        <div className = 'secondPageMain' >
            <h1>Thank you for your contribution, 1 step left</h1>
            <p>Choose areas you are interested in, so we can better set up Ideafy for the release day.</p>
            {/* <div id = 'chooseAreas'> */}




            <Formik
                initialValues={{
                    toggle: false,
                    checked: [],
                    msg:''
                }}
                onSubmit={async (values) => {
                    // const newReferenceMsg = Firebase.firestore().collection(`users/${currentId}/profile`).doc('message')
                    const newReferenceMsg = Firebase.firestore().collection(`users/${email}/profile`).doc('message')
                    console.log('sumbited', values)
                    console.log(values.msg)
                    if (values.checked !== []){
                        values.checked.forEach((item)=>{
                        const newReference = Firebase.firestore().collection(`users/${email}/areas`).doc(item)
                        // const newReference = Firebase.firestore().collection(`users/${currentId}/areas`).doc(item)
                        newReference.set({item})
                        })
                        console.log('finished for each loop')
                    }
                    console.log('after areas')
                    if(values.msg !==''){
                        newReferenceMsg.set({message:values.msg })  
                        console.log('msg sumbitte')
                    }
                    setEmailIsWritten(false)
                    setEmail('')
                    history.push("/")

                    // alert(JSON.stringify(values, null, 2));
                }}
                >
                {({ values,handleSubmit, handleBlur, handleChange }) => (
                    <Form id = 'container'>
                    {/* 
                        Multiple checkboxes with the same name attribute, but different
                        value attributes will be considered a "checkbox group". Formik will automagically
                        bind the checked values to a single array for your benefit. All the add and remove
                        logic will be taken care of for you.
                   
                    {/* <div id="checkbox-group">Checked</div> */}
                    <div role="group" aria-labelledby="checkbox-group" id = 'checkBoxes'>                
                        <label className = 'checkBox'> 
                            <Field component = {CheckboxWithLabel} type="checkbox" name="checked" value="saas"  style = {{color:'#21345E'}}  color ='primary'   />
                            SaaS
                        </label>
                        <label className = 'checkBox'> 
                            <Field component = {CheckboxWithLabel} type="checkbox" name="checked" value="cybersecurity"  style = {{color:'#21345E'}}  color ='primary'   />
                            Cybersecurity
                        </label>
                        <label className = 'checkBox'> 
                            <Field component = {CheckboxWithLabel} type="checkbox" name="checked" value="edtech"  style = {{color:'#21345E'}}  color ='primary'   />
                            Edtech
                        </label>
                        <label className = 'checkBox'> 
                            <Field component = {CheckboxWithLabel} type="checkbox" name="checked" value="retailEcommerce"  style = {{color:'#21345E'}}  color ='primary'   />
                            Retail/Ecommerce
                        </label>
                        <label className = 'checkBox'> 
                            <Field component = {CheckboxWithLabel} type="checkbox" name="checked" value="roboticsIot"  style = {{color:'#21345E'}}  color ='primary'   />
                            Robotics/IoT
                        </label>
                        <label className = 'checkBox'> 
                            <Field component = {CheckboxWithLabel} type="checkbox" name="checked" value="spacetech"  style = {{color:'#21345E'}}  color ='primary'   />
                            Space Tech
                        </label>
                        <label className = 'checkBox'> 
                            <Field component = {CheckboxWithLabel} type="checkbox" name="checked" value="agtech"  style = {{color:'#21345E'}}  color ='primary'   />
                            Agtech
                        </label>
                        <label className = 'checkBox'> 
                            <Field component = {CheckboxWithLabel} type="checkbox" name="checked" value="fintech"  style = {{color:'#21345E'}}  color ='primary'   />
                            Fintech
                        </label>
                        <label className = 'checkBox'> 
                            <Field component = {CheckboxWithLabel} type="checkbox" name="checked" value="healthcare"  style = {{color:'#21345E'}}  color ='primary'   />
                            Healthcare
                        </label>
                        <label className = 'checkBox'> 
                            <Field component = {CheckboxWithLabel} type="checkbox" name="checked" value="entertainmentGaming"  style = {{color:'#21345E'}}  color ='primary'   />
                            Entertainment/Gaming
                        </label>
                    </div>
                    <Field  
                        id="msg"
                        name="msg"
                        placeholder="add comment, if you want"
                        type="text"
                    />
                    <button  id = 'submitBtn' type="submit" >submit</button>
                    </Form>
                )}
            </Formik>
            {/* </div> */}
            {/* <div id = 'submitBtn'></div> */}
        </div>
    )
    
}

export default SumbitInterests